module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsBAMAAADsqkcyAAAAGFBMVEUAAAAmiOMmiuMniOInieInieInieL////euErwAAAABnRSTlMASUrk5udXTd49AAAANklEQVQoz2NgGExAJA0FOEKF3VCFU6DCaeVAgEQMGWE0QEB41JeDWBgtaaZChVVRhY0GVS4DAMRl3fIB4SFlAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/course/kb@2x_.png
// module id = yUFt
// module chunks = 0